import { Button, Modal } from "react-bootstrap";
import { Spinner } from "../components";
import React from "react";

type PopupProps = {
	title?: string;
	show?: boolean;
	backdrop?: "static" | boolean;
	description?: string | React.ReactNode;
	buttonText?: string;
	hideMainButton?: boolean;
	buttonCloseText?: string;
	handleSubmit?: any;
	handleClose?: () => void;
	buttonType?: string;
	size?: "sm" | "lg" | "xl" | undefined;
	disableButtons?: boolean | undefined;
};

export default function Popup({ title, size, show, backdrop, buttonText, description, buttonType, hideMainButton, handleClose, handleSubmit, disableButtons, buttonCloseText }: PopupProps) {
	return (
		<Modal
			centered
			size={size ? size : "sm"}
			show={show}
			keyboard={disableButtons ? false : true}
			animation={true}
			backdrop={backdrop ?? "static"}
			onHide={handleClose}
			onEscapeKeyDown={handleClose}
		>
			<Modal.Dialog className="m-0">
				<Modal.Header closeButton={disableButtons ? false : true}>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div>{description}</div>
				</Modal.Body>

				<Modal.Footer>
					<Button disabled={disableButtons ? disableButtons : false} variant="light" className="cta-button" onClick={handleClose}>
						{buttonCloseText ? buttonCloseText : "Cancel"}
					</Button>
					{hideMainButton != true && (
						<Button disabled={disableButtons ? disableButtons : false} variant={buttonType ?? "danger"} className="cta-button" onClick={handleSubmit}>
							{disableButtons ? (
								<>
									<Spinner className="spinner-border-sm me-1" tag="span" color="white" />
								</>
							) : (
								<></>
							)}
							{buttonText ? buttonText : "Remove"}
						</Button>
					)}
				</Modal.Footer>
			</Modal.Dialog>
		</Modal>
	);
}
